import { render, staticRenderFns } from "./feeItemInfo.vue?vue&type=template&id=1cae4b1e&scoped=true&"
import script from "./feeItemInfo.vue?vue&type=script&lang=js&"
export * from "./feeItemInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cae4b1e",
  null
  
)

export default component.exports